export const CHAT_EVENT = {
    connect: 'connect',
    joinChat: 'join chat',
}
